var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',[_c('b-breadcrumb-item',{attrs:{"to":"/competitors"}},[_vm._v(" Competitors ")]),_c('b-breadcrumb-item',{attrs:{"active":""}},[(_vm.value)?_c('span',[_vm._v(" "+_vm._s(_vm.value.candle_name)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }